export const ADD_TO_COMPARE = "ADD_TO_COMPARE";
export const REMOVE_FROM_COMPARE = "REMOVE_FROM_COMPARE";
export const SET_COMPARE_ITEMS = "SET_COMPARE_ITEMS";
export const CLEAR_COMPARE = "CLEAR_COMPARE";
